import { TrackedTime } from './models/tracked-time.model';
import { IEntityTypePayload } from '../entity-data/entity-data.actions';
import { EntityTypesEnum } from '../../app.enum';

export interface ITrackedTimePayload extends IEntityTypePayload {
  trackedTime: TrackedTime;
}

export interface IBillTrackedTimePayload extends IEntityTypePayload {
  trackedTimeId: string;
  clientReferenceId: string;
}

export interface IErrorPayload extends IEntityTypePayload {
  error: Error;
  data: any[];
}

// action enums
export enum ActionsEnum {
  BILL_TRACKED_TIME = 'BILL_TRACKED_TIME',
  NEW_DRAFT_TRACKED_TIME = 'NEW_DRAFT_TRACKED_TIME',
  SET_DRAFT_TRACKED_TIME = 'SET_DRAFT_TRACKED_TIME',
  CLEAR_DRAFT_TRACKED_TIME = 'CLEAR_DRAFT_TRACKED_TIME',
  SET_DRAFT_TRACKED_TIME_ERROR = 'SET_DRAFT_TRACKED_TIME_ERROR',
}

export interface NewDraftTrackedTime {
  type: ActionsEnum.NEW_DRAFT_TRACKED_TIME;
  payload: IEntityTypePayload;
}

export interface SetDraftTrackedTime {
  type: ActionsEnum.SET_DRAFT_TRACKED_TIME;
  payload: ITrackedTimePayload;
}

export interface ClearDraftTrackedTime {
  type: ActionsEnum.CLEAR_DRAFT_TRACKED_TIME;
  payload: IEntityTypePayload;
}

export interface BillTrackedTime {
  type: ActionsEnum.BILL_TRACKED_TIME;
  payload: IBillTrackedTimePayload;
}

export interface SetDraftTrackedTimeError {
  type: ActionsEnum.SET_DRAFT_TRACKED_TIME_ERROR;
  payload: IErrorPayload;
}

export const newDraftTrackedTime = (
  entityType: EntityTypesEnum
): NewDraftTrackedTime => ({
  type: ActionsEnum.NEW_DRAFT_TRACKED_TIME,
  payload: {
    entityType,
  },
});

export const setDraftTrackedTime = (
  entityType: EntityTypesEnum,
  trackedTime: TrackedTime
): SetDraftTrackedTime => ({
  type: ActionsEnum.SET_DRAFT_TRACKED_TIME,
  payload: {
    entityType,
    trackedTime,
  },
});

export const clearDraftTrackedTime = (
  entityType: EntityTypesEnum
): ClearDraftTrackedTime => ({
  type: ActionsEnum.CLEAR_DRAFT_TRACKED_TIME,
  payload: {
    entityType,
  },
});

export const setDraftTrackedTimeError = (
  entityType: EntityTypesEnum,
  error: Error,
  data?: any[]
): SetDraftTrackedTimeError => ({
  type: ActionsEnum.SET_DRAFT_TRACKED_TIME_ERROR,
  payload: {
    entityType,
    error,
    data,
  },
});

export const billTrackedTime = (
  entityType: EntityTypesEnum,
  trackedTimeId: string,
  clientReferenceId: string
): BillTrackedTime => ({
  type: ActionsEnum.BILL_TRACKED_TIME,
  payload: {
    entityType,
    trackedTimeId,
    clientReferenceId,
  },
});
